import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const committeeTypeApi = generateNomenApi(`/nomen/committee-types`);

export const committeeTypeOptions = generateNomenOptions('committee-type', committeeTypeApi);
